import { SiafLiteApiAI } from "../../external";
import store from "../../config/store";

class AIService {
  constructor() {
    this.urlBase = "ai";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  health() {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/health`).get();
  }

  listAgents(filter) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/agents`).get(filter);
  }

  getAgent(slug) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/agents/${slug}`).get();
  }

  updateAgent(slug, body) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/agents/${slug}`).patch(
      body,
    );
  }

  invokeAgent(slug, body) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/agents/${slug}/invoke`,
    ).post(body);
  }

  invokeAgentStream(slug, body) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/agents/${slug}/stream`,
    ).post(body);
  }

  createChatSession(body) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/chat/sessions`).post(
      body,
    );
  }

  listChatSessions(filter) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/chat/sessions`).get(
      filter,
    );
  }

  getChatSession(id) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/chat/sessions/${id}`,
    ).get();
  }

  deleteChatSession(id) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/chat/sessions/${id}`,
    ).delete(id);
  }

  sendMessage(sessionId, body) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/chat/sessions/${sessionId}/messages`,
    ).post(body);
  }

  sendMessageStream(sessionId, body) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/chat/sessions/${sessionId}/messages/stream`,
    ).postStream(body);
  }

  listInvocations(filter) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/invocations`).get(filter);
  }

  getInvocation(id) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/invocations/${id}`).get();
  }

  listModels(filter) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/models`).get(filter);
  }

  createModel(body) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/models`).post(body);
  }

  getModel(slug) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/models/${slug}`).get();
  }

  updateModel(slug, body) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/models/${slug}`).put(
      slug,
      body,
    );
  }

  deleteModel(slug) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/models/${slug}`).delete(
      slug,
    );
  }

  listCollections(filter) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/rag/collections`).get(
      filter,
    );
  }

  listDocuments(collectionId, filter) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/rag/collections/${collectionId}/documents`,
    ).get(filter);
  }

  uploadDocument(collectionId, formData) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/rag/collections/${collectionId}/documents/upload`,
    ).postFormData(formData);
  }

  deleteDocument(documentId) {
    return new SiafLiteApiAI(`${this.urlBaseCompleta}/rag/documents`).delete(
      documentId,
    );
  }

  getChunk(chunkId) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/rag/chunks/${chunkId}`,
    ).get();
  }

  searchCollection(collectionId, query) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/rag/collections/${collectionId}/search`,
    ).get({ query });
  }

  askCollection(collectionId, body) {
    return new SiafLiteApiAI(
      `${this.urlBaseCompleta}/rag/collections/${collectionId}/ask`,
    ).post(body);
  }
}

export default AIService;
